/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { AxiosRequestConfig } from 'axios';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import qs from 'query-string';

export function makeMockResponse<T>(code: number, data: T, config: AxiosRequestConfig): [number, T] {
    const color = code < 400 ? 'green' : 'red';
    const style = `color: ${color}; font-size: 14px; font-weight: 600`;
    let url = config.url;
    if (config.params) {
        url += '?' + qs.stringify(config.params);
    }
    if (config.data) {
        url += ' body: ' + config.data.toString();
    }
    // tslint:disable-next-line:no-console
    console.log(`%c[mocked]: ${config.method} ${url} => ${code}`, style, data);
    return [code, data];
}

export function parseIntParamFromUrl(re: RegExp, url: string): number {
    return parseInt(url.match(re)[1], 10);
}

export function delayedResponse<T>(data: T, delayMs: number): Promise<T> {
    return of(data).pipe(delay(delayMs)).toPromise();
}
